export class NotificationRepository {
  async getNotifications(userId, { limit = 20, lastVisible = null } = {}) {
    throw new Error('Method not implemented');
  }

  async markAsRead(notificationId) {
    throw new Error('Method not implemented');
  }

  async markAllAsRead(userId) {
    throw new Error('Method not implemented');
  }

  async getUnreadCount(userId) {
    throw new Error('Method not implemented');
  }
} 